import Button from 'components/button'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import { Question, SurveyResponse } from 'contexts/survey-context/survey.interface'
import { useState } from 'react'
import Options from '../../options'
import StepperComponent from './StepperComponent'

interface IProps {
  changeStep: (count: string) => void
  answers: any
  questions: Question[]
  id: number;
  handleSubmit: (callback: () => Promise<void>) => void
  updatePolarisSurvey: (select: SurveyResponse[][], id: number) => Promise<void>
}

const StepRepresents = ({ changeStep, answers, questions, handleSubmit, updatePolarisSurvey, id }: IProps) => {
  const [selected, setSelected] = useState<Record<string, number[]>>({})
  const [textValue, setTextValue] = useState<Record<string, string>>({})

  const validateAmountAnwsers = (select: any) => {
    const selectedFilter = select?.filter((item, index) => {
      let amountAnswers = questions[index]?.type === 'Normal' ? questions[index]?.amountAwnsers : 1
      if (questions[index]?.type === 'Normal') {
        const anwser = questions[index]?.options.filter(
          (o) => (item as any)?.optionIds.find((x) => x === o.optionId) === o.optionId
        )
        if (anwser.some((o) => o.demandSpaceId === 0)) {
          amountAnswers = 0
        }
      }
      return (item as any)?.optionIds.length < amountAnswers
    })
    return selectedFilter?.length > 0
  }

  async function onFormSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()

    dlTrackEvent('form_send', {
      element: 'Responder',
      form_name: 'vl26',
      section: 'survey :: vl26'
    })

    const select = []

    for (const key in selected) {
      select.push({ questionId: parseInt(key), optionIds: selected[key], textValue: textValue[key] !== '' ? textValue[key] : null })
    }

    if (validateAmountAnwsers(select)) {
      dlTrackEvent('error', {
        error_type: 'survey',
        error_code: 9999,
        error_message: 'Por favor, responde todas las preguntas',
        section: `survey :: vl26`
      })
      return alert('Por favor, responde todas las preguntas')
    }

    answers.push(...select)
    await handleSubmit(async () => await updatePolarisSurvey(answers as any as SurveyResponse[][], id))
    changeStep('increment')
  }

  return (
    <StepperComponent
      handleSubmit={onFormSubmit}
    >
      {questions?.map(({ questionId, question, subtitle, options, type, amountAwnsers }, index) => (
        <Options
          onChange={(data, select, value) => {
            setTextValue((state) => ({ ...state, [data]: value }))
            setSelected((state) => ({ ...state, [data]: select.map((id) => +id) }))
          }}
          options={options}
          question={question}
          subtitle={subtitle}
          questionId={questionId}
          type={type}
          key={index}
          amountAnswers={amountAwnsers}
          columns={2}
        />
      ))}

      <div className="mt-10 mb-5 flex flex-col">
        <Button className="w-full">
          Responder
        </Button>
      </div>
    </StepperComponent>
  )
}

export default StepRepresents
